export const pending = actionType => `${actionType}_PENDING`
export const fulfilled = actionType => `${actionType}_FULFILLED`
export const rejected = actionType => `${actionType}_REJECTED`
